import React from 'react';
import { useFormikContext } from 'formik';
import { Checkbox } from '../../../../Checkbox';
import { Button } from '../../../../Button';
import styles from './shipFilterCheckboxes.module.sass';

export const ShipFilterCheckboxes = ({
  name,
  items,
  title,
  isLoading,
  onShowMore,
  isOpen,
}) => {
  const { setFieldValue } = useFormikContext();

  return (
    <div>
      <header className={styles.header}>
        <p className={styles.title}>{title}</p>
        <Button view="text" onClick={() => setFieldValue(name, [])}>
          Очистить
        </Button>
      </header>
      <main className={styles.body}>
        {!!items.length &&
          items.map(({ lable, value, checked = false, count }, index) => (
            <div className={styles.item} key={index}>
              <Checkbox
                size="sm"
                name={name}
                value={value}
                checked={checked}
                disabled={isLoading}
              >
                {lable}
              </Checkbox>
              <div className={styles.info}>
                <span className={styles.count}>{count}</span>
              </div>
            </div>
          ))}
      </main>

      {onShowMore && (
        <footer className={styles.footer}>
          <Button view="text" onClick={onShowMore}>
            {isOpen ? 'Скрыть' : 'Показать еще'}
          </Button>
        </footer>
      )}
    </div>
  );
};

ShipFilterCheckboxes.defaultProps = {
  items: [],
};
